module.exports = __webpack_public_path__ + "fonts/AudiType-Normal_4.03.a6ea1e4f.woff";